/* eslint-disable */
import Vue from 'vue'
import {
    Button,
    Container,
    Header,
    Aside,
    Main,
    Footer,
    Card,
    Form,
    FormItem,
    Input,
    Menu,
    MenuItem,
    Pagination,
    Select,
    Option,
    Dialog,
    InputNumber,
    DatePicker,
    Upload,
    Image,
    Radio,
    RadioGroup,
    Message,
    Tag,
    Steps,
    Step,
    Loading,
    Table,
    TableColumn
} from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Upload)
Vue.use(Image)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Tag)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Loading.directive)
Vue.use(Table)
Vue.use(TableColumn)

Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service